import { Dialog, DialogContent, DialogTitle } from 'src/components/ui/dialog';
import React, { useEffect, useState } from 'react';
import { Button } from 'src/components/ui/button';
import { useAppSelector } from 'src/store';
import { useDispatch } from 'react-redux';
import { setSuccess } from 'src/store/slices/onboardingSlice';

export const SuccessOnboardingPopup = () => {
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const { success } = useAppSelector((s) => s.onboardingSlice);

  useEffect(() => {
    if (success) {
      setOpen(true);
    }
  }, [success]);

  const onOpenChange = (isOpen) => {
    if (!isOpen) {
      dispatch(setSuccess(false));
    }

    setOpen(isOpen);
  };

  return (
    <Dialog onOpenChange={onOpenChange} open={open}>
      <DialogContent
        closeButtonHidden={true}
        className={
          'max-w-[580px] py-12 px-7 gap-5 bg-[linear-gradient(23deg,#F6FFE8_0.5%,#E2FFEC_25.51%,#E2F9FF_58.74%,#E5F1FE_98.59%)]'
        }
      >
        <DialogTitle className={'flex flex-col gap-[15px]'}>
          <div className={'flex flex-col items-center justify-center gap-1'}>
            <p className={'text-2xl uppercase text-ebony font-bold'}>🎉 You’re all set 🎉</p>
            <p className={'text-ebony text-base font-medium'}>
              Your AI agent is ready for testing.
            </p>
          </div>
          <div>
            <p className={'text-center text-ebony_opacity_80 text-base leading-[150%]'}>
              Try it out in the Playground — see how it responds before you connect it to your
              helpdesk and go live.
            </p>
          </div>
        </DialogTitle>

        <div className={'flex justify-center items-center'}>
          <Button
            variant={'green'}
            className={'text-lg px-5 py-5 font-semibold'}
            onClick={() => onOpenChange(false)}
          >
            <p>Try My Agent</p>
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
